'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIProgress from 'UIComponents/progress/UIProgress';
import PDFLoadingImageBackground from './PDFLoadingImageBackground';

const PDFLoading = ({
  pageIndex,
  imagePlaceholders,
  value = 0
}) => /*#__PURE__*/_jsx(PDFLoadingImageBackground, {
  pageIndex: pageIndex,
  imagePlaceholders: imagePlaceholders,
  children: /*#__PURE__*/_jsx(UIProgress, {
    className: "pdf-loading m-bottom-0",
    value: value
  })
});

PDFLoading.propTypes = {
  value: PropTypes.number,
  imagePlaceholders: PropTypes.array.isRequired,
  pageIndex: PropTypes.number.isRequired
};
export default PDFLoading;